module.exports = __webpack_public_path__ + "img/modal-document-null.e2a04b18.svg";